import { API_AUTH_URL } from "@/constants";
import { fetchWithAuthUserId } from "./campaignService";

export async function linkRequest(payload) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
    };
    return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/brand/link-request?brandId=${payload.brandId}`, requestOptions)
}

export async function delinkRequest(payload) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body: JSON.stringify(payload),
    };
    return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/brand/de-link-request`, requestOptions)
}

export async function agencyBrandLink(payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
  };
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/brand/link?agencyId=${payload.agencyId}&approvalStatus=${payload.approvalStatus}`, requestOptions)
}

export async function getApprovalList() {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/approval/listing`, {
      method: 'GET',
    })
}

export async function getApprovalDetails(userId, userType) {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/${userType}/${userId}`, {
      method: 'GET',
    })
}

export async function updateApprovalStatus(userId, userType, payload) {
  const requestOptions = {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json'},
    body: payload.comments,
  };
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/${userType}/${userId}?accountStatus=${payload.accountStatus}`, requestOptions)
}

export async function getDeLinkList() {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/de-link-request/listing`, {
      method: 'GET',
    })
}

export async function getLinkList() {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/link-request/listing`, {
      method: 'GET',
    })
}

export async function agencyBrandDeLink(payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(payload),
  };
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/brand/de-link`, requestOptions)
}

export async function getLinkHistoryList() {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/link-request/history`, {
      method: 'GET',
    })
}

export async function getUserManagementDetails() {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/userManagement/details`, {
      method: 'GET',
    })
}

export async function getUserProfileDetails(agencyId) {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/userManagement/userProfileDetails/${agencyId}`, {
      method: 'GET',
    })
}

export async function updateUserRole(payload) {
  const {email, newRole, comments} = payload;
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json'},
  };
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/userManagement/updateRole?email=${email}&newRole=${newRole}&comments=${comments}`, requestOptions)
}

export async function updateAccountStatus(payload) {
  const {email, action, comments} = payload;
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json'},
  };
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/userManagement/updateAccountStatus?email=${email}&action=${action}&comments=${comments}`, requestOptions)
}

export async function getLinkedAgencies(brandId) {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/linkedAgencies/${brandId}`, {
      method: 'GET',
    })
}

export async function getLinkedBrands(agencyId) {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/linkedBrands/${agencyId}`, {
      method: 'GET',
    })
}

export async function downloadAllProfileDetails() {
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/userManagement/downloadProfileDetails`, {
      method: 'GET',
    })
}